import React from 'react';
import { Helmet } from 'react-helmet';

const SITE_URL = 'https://holywearhouse.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;

export default function SEO({
  title,
  description,
  keywords = [],
  path = '/',
  image = DEFAULT_IMAGE,
  noIndex = false,
  structuredData,
  children,
}) {
  const canonicalUrl = `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
  const keywordString = Array.isArray(keywords) ? keywords.join(', ') : keywords;
  const structuredDataList = Array.isArray(structuredData)
    ? structuredData.filter(Boolean)
    : structuredData
      ? [structuredData]
      : [];

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywordString && <meta name="keywords" content={keywordString} />}
      <link rel="canonical" href={canonicalUrl} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {structuredDataList.map((schema, index) => (
        <script
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          key={`structured-data-${index}`}
          type="application/ld+json"
        />
      ))}

      {children}
    </Helmet>
  );
}
